import '../../css/Notfound.css'
import { Row, Col, Typography, Button, Space } from "antd";
import { useParams } from 'react-router-dom';

const { Title, Text } = Typography;

export const NotFound = () => {
    const { APP_ID } = useParams();

    const returnHome = async()=>{
        window.location.href = `https://sso2-dev.scgd.co/${APP_ID}`;
    }
    
    return (
        <>
        <Row 
            justify="space-around"
            align="middle"
            style={{
            height: '100vh'
            }}
        >
            <Col>
                <div className='nofoundcard'>
                    <Space direction="vertical" style={{
                        position: 'absolute',
                        bottom: '15%',
                        left: '13%',
                        right: '13%',
                    }}>
                    <Title level={5}>We could not find the page you're looking for</Title>
                    <div style={{
                        textAlign: 'left'
                    }}>
                        <Text >
                            The link you're trying to access is probably broken, or the page has been removed.
                        </Text>
                    </div>
                    {/* <Text type="danger">User doesn't exist in SSO please contact administrator</Text> */}
                    {APP_ID && 
                        <Button onClick={()=>{returnHome()}} style={{
                            width: '50%',
                            backgroundColor: '#63CABD',
                            color: 'white',
                            marginTop: '10px'
                        }}>Return Home</Button>
                    }
                    </Space>
                </div>
            </Col>
        </Row>
        </>
    )
}